var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "uploading-progress-bar-container" }, [
    _c("div", { staticClass: "d-flex align-items-center gap-10px" }, [
      _c(
        "svg",
        {
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            width: "18",
            height: "19",
            viewBox: "0 0 18 19",
            fill: "none",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M9 2.1875C10.9394 2.1875 12.7994 2.95792 14.1707 4.32928C15.5421 5.70064 16.3125 7.5606 16.3125 9.5C16.3125 11.4394 15.5421 13.2994 14.1707 14.6707C12.7994 16.0421 10.9394 16.8125 9 16.8125C7.0606 16.8125 5.20064 16.0421 3.82928 14.6707C2.45792 13.2994 1.6875 11.4394 1.6875 9.5C1.6875 7.5606 2.45792 5.70064 3.82928 4.32928C5.20064 2.95792 7.0606 2.1875 9 2.1875ZM9 18.5C11.3869 18.5 13.6761 17.5518 15.364 15.864C17.0518 14.1761 18 11.8869 18 9.5C18 7.11305 17.0518 4.82387 15.364 3.13604C13.6761 1.44821 11.3869 0.5 9 0.5C6.61305 0.5 4.32387 1.44821 2.63604 3.13604C0.948212 4.82387 0 7.11305 0 9.5C0 11.8869 0.948212 14.1761 2.63604 15.864C4.32387 17.5518 6.61305 18.5 9 18.5ZM12.9727 7.84766C13.3031 7.51719 13.3031 6.98281 12.9727 6.65586C12.6422 6.32891 12.1078 6.32539 11.7809 6.65586L7.87852 10.5582L6.22617 8.90586C5.8957 8.57539 5.36133 8.57539 5.03437 8.90586C4.70742 9.23633 4.70391 9.7707 5.03437 10.0977L7.28437 12.3477C7.61484 12.6781 8.14922 12.6781 8.47617 12.3477L12.9727 7.84766Z",
              fill: "#0B7335",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c("strong", [_vm._v(_vm._s(_vm._f("trans")("Finished!")))]),
    ]),
    _vm._v(" "),
    _c("strong", { domProps: { innerHTML: _vm._s(_vm.renderText) } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }